import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { ReleaseEnvironment } from '../../../../types/releaseEnvironment';
import {
  REGISTRATION_STEP,
  RegistrationStep,
} from '../../../../constants/registrationStep';

/**
 * リリース環境更新画面の状態
 */
interface EditState {
  /** ロード状態 */
  loading: boolean;
  /** 表示中の環境 */
  selected: ReleaseEnvironment | null;
  /** 削除確認モーダルの表示状態 */
  isOpenModalDelete: boolean;
  /** 基本情報の更新確認モーダルの表示状態 */
  isOpenModalEdit: boolean;
  /** バージョン追加ステップ */
  step: RegistrationStep;
}

/**
 * リリース環境更新画面の初期状態
 */
const initialState: EditState = {
  step: REGISTRATION_STEP.INPUT,
  loading: false,
  selected: null,
  isOpenModalDelete: false,
  isOpenModalEdit: false,
};

/**
 * リリース環境更新画面の slice(reducer + action)
 */
export const editSlice = createSlice({
  name: 'editReleaseEnvironment',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (
      state,
      { payload }: PayloadAction<EditState['selected']>,
    ) => ({
      ...state,
      selected: payload,
    }),
    updateLoadingStatus: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      loading: payload,
    }),
    updateIsOpenModalDelete: (state, { payload }: PayloadAction<boolean>) => ({
      ...state,
      isOpenModalDelete: payload,
    }),
    updateIsOpenModalEditDetail: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => ({
      ...state,
      isOpenModalEditDetail: payload,
    }),
  },
});

/**
 * リリース環境更新画面の action
 */
export const editActions = editSlice.actions;

/**
 * リリース環境更新画面の selectors
 */
export const editSelectors = {
  selectedReleaseEnvironment: (state: RootState) =>
    state.releaseEnvironment.edit.selected,
  isOpenModalDelete: (state: RootState) =>
    state.releaseEnvironment.edit.isOpenModalDelete,
  isOpenModalEdit: (state: RootState) =>
    state.releaseEnvironment.edit.isOpenModalEdit,
  currentModalStep: (state: RootState) =>
    state.releaseEnvironment.registration.step,
} as const;
